const errorTranslations = {
  ar: {
    contact_site_admin:
      'يرجى التواصل مع مسؤول الموقع للتأكد من تكوين هذا النموذج بشكل صحيح.',
    sorry_something_went_wrong: 'عذراً. حدث خطأ ما.',
    support_id: 'رقم الدعم',
  },
  zh: {
    contact_site_admin: '请联系网站管理员以确保此表单配置正确。',
    sorry_something_went_wrong: '抱歉。发生了一些问题。',
    support_id: '支持ID',
  },
  'zh-CN': {
    contact_site_admin: '请联系网站管理员以确保此表单配置正确。',
    sorry_something_went_wrong: '抱歉。发生了一些问题。',
    support_id: '支持ID',
  },
  'zh-HK': {
    contact_site_admin: '請聯絡網站管理員以確保此表單已正確配置。',
    sorry_something_went_wrong: '對不起。出了一些問題。',
    support_id: '支援ID',
  },
  'zh-TW': {
    contact_site_admin: '請聯絡網站管理員以確保此表單已正確配置。',
    sorry_something_went_wrong: '抱歉。發生了一些問題。',
    support_id: '支援ID',
  },
  hr: {
    contact_site_admin:
      'Molimo kontaktirajte administratora web stranice kako biste osigurali da je ovaj obrazac ispravno konfiguriran.',
    sorry_something_went_wrong: 'Žao mi je. Došlo je do neke greške.',
    support_id: 'ID podrške',
  },
  cs: {
    contact_site_admin:
      'Prosím, kontaktujte správce webu, aby byl tento formulář správně nakonfigurován.',
    sorry_something_went_wrong: 'Omlouváme se. Něco se pokazilo.',
    support_id: 'ID podpory',
  },
  da: {
    contact_site_admin:
      'Kontakt venligst webadministratoren for at sikre, at denne formular er korrekt konfigureret.',
    sorry_something_went_wrong: 'Beklager. Noget gik galt.',
    support_id: 'Support-ID',
  },
  nl: {
    contact_site_admin:
      'Neem contact op met de sitebeheerder om ervoor te zorgen dat dit formulier correct is geconfigureerd.',
    sorry_something_went_wrong: 'Sorry. Er is iets misgegaan.',
    support_id: 'Ondersteunings-ID',
  },
  'nl-BE': {
    contact_site_admin:
      'Gelieve contact op te nemen met de sitebeheerder om ervoor te zorgen dat dit formulier correct is geconfigureerd.',
    sorry_something_went_wrong: 'Sorry. Er is iets fout gegaan.',
    support_id: 'Ondersteunings-ID',
  },
  en: {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-AU': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-CA': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-IN': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-ID': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Maaf. Terjadi kesalahan.',
    support_id: 'Support ID',
  },
  'en-IL': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-NA': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-NZ': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-PH': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-SG': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-ZA': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-GB': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-AE': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  'en-US': {
    contact_site_admin:
      'Please contact the site administrator to ensure this form is configured correctly.',
    sorry_something_went_wrong: 'Sorry. Something went wrong.',
    support_id: 'Support ID',
  },
  fi: {
    contact_site_admin:
      'Ole hyvä ja ota yhteys sivuston ylläpitäjään varmistaaksesi, että tämä lomake on määritetty oikein.',
    sorry_something_went_wrong: 'Anteeksi. Jotain meni pieleen.',
    support_id: 'Tukitunnus',
  },
  fr: {
    contact_site_admin:
      "Veuillez contacter l'administrateur du site pour vous assurer que ce formulaire est correctement configuré.",
    sorry_something_went_wrong: "Désolé. Quelque chose s'est mal passé.",
    support_id: 'ID de support',
  },
  'fr-BE': {
    contact_site_admin:
      "Veuillez contacter l'administrateur du site pour vous assurer que ce formulaire est correctement configuré.",
    sorry_something_went_wrong: "Désolé. Quelque chose s'est mal passé.",
    support_id: 'ID de support',
  },
  'fr-CA': {
    contact_site_admin:
      "Veuillez contacter l'administrateur du site pour vous assurer que ce formulaire est correctement configuré.",
    sorry_something_went_wrong: "Désolé. Quelque chose s'est mal passé.",
    support_id: 'ID de support',
  },
  'fr-CH': {
    contact_site_admin:
      "Veuillez contacter l'administrateur du site pour vous assurer que ce formulaire est correctement configuré.",
    sorry_something_went_wrong: "Désolé. Quelque chose s'est mal passé.",
    support_id: 'ID de support',
  },
  de: {
    contact_site_admin:
      'Bitte kontaktieren Sie den Website-Administrator, um sicherzustellen, dass dieses Formular korrekt konfiguriert ist.',
    sorry_something_went_wrong: 'Entschuldigung. Etwas ist schiefgegangen.',
    support_id: 'Support-ID',
  },
  'de-AT': {
    contact_site_admin:
      'Bitte kontaktieren Sie den Website-Administrator, um sicherzustellen, dass dieses Formular korrekt konfiguriert ist.',
    sorry_something_went_wrong: 'Entschuldigung. Etwas ist schiefgegangen.',
    support_id: 'Support-ID',
  },
  'de-CH': {
    contact_site_admin:
      'Bitte kontaktieren Sie den Website-Administrator, um sicherzustellen, dass dieses Formular korrekt konfiguriert ist.',
    sorry_something_went_wrong: 'Entschuldigung. Etwas ist schiefgelaufen.',
    support_id: 'Support-ID',
  },
  el: {
    contact_site_admin:
      'Παρακαλούμε επικοινωνήστε με τον διαχειριστή του ιστότοπου για να διασφαλίσετε ότι αυτή η φόρμα έχει διαμορφωθεί σωστά.',
    sorry_something_went_wrong: 'Λυπούμαστε. Κάτι πήγε στραβά.',
    support_id: 'Αναγνωριστικό υποστήριξης',
  },
  he: {
    contact_site_admin:
      'אנא צרו קשר עם מנהל האתר כדי לוודא שהטופס הזה מוגדר כראוי.',
    sorry_something_went_wrong: 'מצטערים. משהו השתבש.',
    support_id: 'מזהה תמיכה',
  },
  hu: {
    contact_site_admin:
      'Kérjük, lépjen kapcsolatba az oldal adminisztrátorával annak érdekében, hogy meggyőződjön arról, hogy ez a űrlap megfelelően van konfigurálva.',
    sorry_something_went_wrong: 'Elnézést. Valami hiba történt.',
    support_id: 'Támogatási azonosító',
  },
  id: {
    contact_site_admin:
      'Silakan hubungi administrator situs untuk memastikan bahwa formulir ini dikonfigurasi dengan benar.',
    sorry_something_went_wrong: 'Maaf. Ada yang salah.',
    support_id: 'ID Dukungan',
  },
  it: {
    contact_site_admin:
      "Si prega di contattare l'amministratore del sito per assicurarsi che questo modulo sia configurato correttamente.",
    sorry_something_went_wrong: 'Scusa. Qualcosa è andato storto.',
    support_id: 'ID di supporto',
  },
  ja: {
    contact_site_admin:
      'このフォームが正しく設定されていることを確認するために、サイト管理者にお問い合わせください。',
    sorry_something_went_wrong: 'すみません。何かがうまくいきませんでした。',
    support_id: 'サポートID',
  },
  ko: {
    contact_site_admin:
      '이 양식이 올바르게 구성되었는지 확인하려면 사이트 관리자에게 연락하세요.',
    sorry_something_went_wrong: '죄송합니다. 문제가 발생했습니다.',
    support_id: '지원 ID',
  },
  lt: {
    contact_site_admin:
      'Norėdami užtikrinti, kad šis forma būtų tinkamai sukonfigūruotas, prašome susisiekti su svetainės administratoriumi.',
    sorry_something_went_wrong: 'Atsiprašome. Kažkas nutiko negerai.',
    support_id: 'Paramos ID',
  },
  ms: {
    contact_site_admin:
      'Sila hubungi pentadbir laman web untuk memastikan borang ini dikonfigurasi dengan betul.',
    sorry_something_went_wrong: 'Maaf. Sesuatu telah berlaku kesalahan.',
    support_id: 'ID Sokongan',
  },
  nb: {
    contact_site_admin:
      'Vennligst kontakt nettstedets administrator for å sikre at dette skjemaet er konfigurert riktig.',
    sorry_something_went_wrong: 'Beklager. Noe gikk galt.',
    support_id: 'Støtte-ID',
  },
  pl: {
    contact_site_admin:
      'Prosimy skontaktować się z administratorem strony, aby upewnić się, że ten formularz jest poprawnie skonfigurowany.',
    sorry_something_went_wrong: 'Przepraszamy. Wystąpił problem.',
    support_id: 'ID wsparcia',
  },
  pt: {
    contact_site_admin:
      'Por favor, entre em contato com o administrador do site para garantir que este formulário esteja configurado corretamente.',
    sorry_something_went_wrong: 'Desculpa. Algo correu mal.',
    support_id: 'ID de suporte',
  },
  'pt-BR': {
    contact_site_admin:
      'Por favor, entre em contato com o administrador do site para garantir que este formulário esteja configurado corretamente.',
    sorry_something_went_wrong: 'Desculpe. Algo deu errado.',
    support_id: 'ID de suporte',
  },
  'pt-PT': {
    contact_site_admin:
      'Por favor, entre em contato com o administrador do site para garantir que este formulário esteja configurado corretamente.',
    sorry_something_went_wrong: 'Desculpa. Algo correu mal.',
    support_id: 'ID de suporte',
  },
  ro: {
    contact_site_admin:
      'Vă rugăm să contactați administratorul site-ului pentru a vă asigura că acest formular este configurat corect.',
    sorry_something_went_wrong: 'Scuze. A intervenit o eroare.',
    support_id: 'ID de suport',
  },
  sk: {
    contact_site_admin: 'Prosím',
    sorry_something_went_wrong: 'Prepáčte. Niečo sa pokazilo.',
    support_id: 'ID podpory',
  },
  es: {
    contact_site_admin:
      'Por favor, contacte con el administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Lo siento. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-ES': {
    contact_site_admin:
      'Por favor, contacte con el administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Lo siento. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-AR': {
    contact_site_admin:
      'Por favor, contacte con el administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Perdón. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-MX': {
    contact_site_admin:
      'Por favor, contacte al administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Disculpa. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-CO': {
    contact_site_admin:
      'Por favor, contacte al administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Perdón. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-CL': {
    contact_site_admin:
      'Por favor, contacte al administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Disculpa. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-PE': {
    contact_site_admin:
      'Por favor, contacte al administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Perdón. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  'es-US': {
    contact_site_admin:
      'Por favor, contacte al administrador del sitio para asegurarse de que este formulario esté configurado correctamente.',
    sorry_something_went_wrong: 'Lo siento. Algo salió mal.',
    support_id: 'ID de soporte',
  },
  sv: {
    contact_site_admin:
      'Var god kontakta webbplatsadministratören för att säkerställa att detta formulär är korrekt konfigurerat.',
    sorry_something_went_wrong: 'Ursäkta. Något gick fel.',
    support_id: 'Support-ID',
  },
  th: {
    contact_site_admin:
      'โปรดติดต่อผู้ดูแลเว็บไซต์เพื่อให้แน่ใจว่าแบบฟอร์มนี้ได้รับการกำหนดค่าอย่างถูกต้อง',
    sorry_something_went_wrong: 'ขออภัย มีบางอย่างผิดพลาด',
    support_id: 'รหัสการสนับสนุน',
  },
  tr: {
    contact_site_admin:
      'Bu formun doğru şekilde yapılandırıldığından emin olmak için lütfen site yöneticisiyle iletişime geçin.',
    sorry_something_went_wrong: 'Üzgünüm. Bir şeyler yanlış gitti.',
    support_id: 'Destek Kimliği',
  },
  vi: {
    contact_site_admin:
      'Vui lòng liên hệ với quản trị viên trang web để đảm bảo biểu mẫu này được cấu hình đúng.',
    sorry_something_went_wrong: 'Xin lỗi. Đã xảy ra lỗi.',
    support_id: 'ID Hỗ trợ',
  },
};

export default errorTranslations;
